import script from "./WinnerTakesAllSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./WinnerTakesAllSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./WinnerTakesAllSwitch.vue?vue&type=style&index=0&id=7baad6da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7baad6da"]])

export default __exports__